import {
    showLoader,
    hideLoader,
    setShowBackdrop,
    setReactState,
    setAngularState,
    setCloseReactIframePopup,
    setQuickHelpSource,
    angularPopupIsListening,
    setCsvHandler,
    setAngularPath,
    setPageName
} from "../redux/rootManagerSlice";
import {store} from "../redux/store";
import {assumeUser, logout} from "../redux/authSlice";
import {generateUpgradeLink, getBoxSettingProperties, getQueryObject, openLimitedPackageModal, openUpgrade360Link, sendDataEvent} from "./Helpers";
import {getAutoActions, getBoxCancelReasons, getBoxSuspendReasons, updateBox, getBoxSettings} from "../redux/boxSlice";
import i18next from "i18next";
import { getRedirectLinkToStripeConnect, isMobile } from "./Helpers";
import {t} from "./i18n";
import { openStepperModal } from "./stepperService";
import {
    CREATE_EVENT_MODAL,
    openModal,
    SETTINGS_VALUE_MODAL,
    MULTIPLE_RECURRING_PRICE_UPDATE_MODAL,
    WHATSAPP_INTEGRATION_MODAL,
    MEMBERSHIP_TYPE_PROPS_MODAL, USER_AI_SUMMARY_MODAL,
    VIEW_USER_NOTE_MODAL, hideModal, EVENT_MANAGEMENT_MODAL,
    CONNECT_TO_INBOX_AI_MODAL, CREATE_USER_MODAL
} from "../redux/modalManagerSlice";
import { flowOptions } from "../components/Structure/Schedule/Popups/CreateEvent/FlowOptions";
import { clearUserFlow } from "../redux/UserFlowSlice";
import {cleanStepper, toggleStepperSuccess} from "../redux/stepperSlice";
import {fetchApi, fetchApiStream} from "./HTTP";
import {CHARGE_SETTING, TOAST_TYPE, USER_FIELDS, USER_SITE_FIELDS} from "./ConstHelper";
import {setSidebarCounter, setSuccessFlag} from "../redux/tasksSlice";
import Bugsnag from "@bugsnag/js";
import {getScheduleCustomFields} from "../redux/ScheduleSlice";
import {
    CANCEL_REASONS, LEAD_SOURCE_TYPE, LEAD_STATUS_TYPE,
    LOST_REASONS_TYPE,
    SEASONS, SITE_PIXEL,
    SITE_PURCHASE_LIMITATIONS,
    SUSPEND_REASONS,
    BRANDED_APP_SETTINGS,
} from "../Configs/SettingsValueModalOptions";
import {setRecurringPaymentsFilters} from "../redux/userSettingsSlice";
import {setThreadId} from "../redux/aiSlice";


/*------- OLD REACT INTEGRATION --------- */
export const formatOldReactQueryParams = (data) => {
    return `baseEp=${process.env.REACT_APP_API_URL}&lang_id=${store.getState().userSettings.lang?.id}&box_id=${data?.box_id}&token=${data?.token}`;
}

export const getReactIframeUrlByPath = (path, data) => {
    return `${process.env.REACT_APP_IFRAME_URL}/${path}?${formatOldReactQueryParams(data)}`;
}

/*------- ANGULAR INTEGRATION --------- */

export const formatOldAngularQueryParams = (data) => {
    return "boxId=" + data?.box_id + "&token=" + data?.token + "&langId=" + store.getState().userSettings.lang?.id + "&userBoxId=" + store.getState().user?.user?.id + "&isArgaz=" + !!store.getState().auth?.data?.originalUser;
}

export const getAngularIframeUrlByPath = (path, data, withParams) => {
    if (!data) return "";
    return `${process.env.REACT_APP_WRAPPER_URL}/#/fragment/${path}${withParams ? '&' : '?'}${formatOldAngularQueryParams(data)}`;
}

export const openAngularPopup = (path, angularPopupIsListen, payload) => {
    if (!(store.getState().rootManager.angularPopupIsListening || angularPopupIsListen)) return;
    const userContext = store.getState().auth.data;
    if (path.includes('createUser')) {
        const boxesSettings = store.getState().box.box.settings;
        sendMessageToAngular("angularPopupHandler", {...(payload || getQueryObject(path.split('?')[1])), boxesSettings});
    } else {
        sendMessageToAngular("angularPopupHandler", payload || getQueryObject(path.split('?')[1]));
    }
    return getAngularIframeUrlByPath(path, userContext, true);
}

// Iframes sets

const microAppActionsHandler = (data, dispatch) => {
    const has = (permission) => store.getState().user?.user.permissions.includes(permission);
    if (data.source === 'angular') {
        switch (data.action) {
            case "close_popup":
                dispatch(setAngularState(false));
                break;
            case "show_backdrop":
                dispatch(setShowBackdrop(true));
                break;
            case "hide_backdrop":
                dispatch(setShowBackdrop(false));
                break;
            case "show_loader":
                dispatch(showLoader());
                break;
            case "hide_loader":
                dispatch(hideLoader());
                break;
            case "assume_user":
                (async () => {
                    await dispatch(assumeUser(data.payload));
                    if(data.payload.path){
                        window.location.replace(data.payload.path);
                        dispatch(setAngularState({navigate: data.payload.path }));
                    }
                    else window.location.reload();
                })()
                break;
            case "navigate_report":
                dispatch(setAngularState({navigate: `/reports/${data.payload.reportName}`}));
                break;
            case "open_quickHelp":
                dispatch(setQuickHelpSource(t(data.payload.path)));
                break;
            case "logout":
                dispatch(logout());
                break;
            case "go_to":
                if(!data.payload.permission || (data.payload.permission && has(data.payload.permission))) {
                    dispatch(setAngularState({navigate: data.payload.path}));
                }else{
                    dispatch(setAngularState({navigate: '/dashboard'}));
                }
                break;
            case "updateBox":
                dispatch(updateBox({
                    bio: data.payload.bio,
                    time_card: data.payload.time_card
                }));
                break;
            case "open_drawer":
                dispatch(setReactState(data.payload));
                break;
            case "add_to_schedule":
                if (store.getState().box?.box?.view_external_shcedule) {
                    dispatch(updateBox({view_external_shcedule: false}));
                }
                break;
            case "add_to_tasks":
                dispatch(updateBox({view_external_tasks: false}));
                break;
            case "add_to_forms":
                dispatch(updateBox({view_external_forms: false}));
                break;
            case "add_to_leads":
                dispatch(updateBox({view_external_leads: false}));
                break;
            case "purchase_to_member":
                dispatch(updateBox({view_external_members: false}));
                break;
            case "time_clock_in":
                dispatch(updateBox({time_card_in: true }))
                break;
            case "time_clock_out":
                dispatch(updateBox({time_card_in: false }))
                break;
            case "update_box_settings":
                dispatch(updateBox({settings: {...store.getState().box?.box?.settings || {}, [data.payload.key]: data.payload.value}}))
                break;
            case 'send_freshpaint_event':
                sendDataEvent(data.payload.eventName, data.payload.metadata);
                break;
            case "angular_popup_listner":
                dispatch(angularPopupIsListening());
                break;
            case "export_to_csv":
                dispatch(setCsvHandler(data.payload));
                break;
            case 'open_new_message_modal':
            openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                props: { initSelection: flowOptions.MESSAGE, navigate: () => null, target: data.payload.target},
                onClose: () => dispatch(cleanStepper())})
                break;
            case 'open_staff_modal':
            openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                props: { initSelection: flowOptions.STAFF_MEMBER, navigate: (href) => dispatch(setAngularState({navigate: href}))},
                onClose: () => dispatch(clearUserFlow())})
                break;
            case 'open_task_modal':
                const taskModal = store.getState().modalManager;
                if (taskModal[CREATE_EVENT_MODAL]?.isOpen) return;
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                    props: { initSelection: flowOptions.TASK_FLOW, addAnother: data.payload.target?.id? false : true, navigate: () => {}, target: data.payload.target},
                    onClose: () => dispatch(cleanStepper())})
                    break;
            case 'open_email_after_purchase':
                const modalManager = store.getState().modalManager;
                if (modalManager[CREATE_EVENT_MODAL]?.isOpen) return;
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                    props: { initSelection: flowOptions.EMAIL_AFTER_PURCHASE, navigate: () => {}, target: data.payload.target},
                    onClose: () => dispatch(cleanStepper())})
                break;
            case 'open_penalty_modal':
                const modalManagerCheck = store.getState().modalManager;
                if (modalManagerCheck[CREATE_EVENT_MODAL]?.isOpen) return;
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                    props: { initSelection: flowOptions.PENALTY_FLOW, navigate: () => {}, target: data.payload.penalty, all: data.payload.all},
                    onClose: () => dispatch(cleanStepper())})
                break;
            case 'open_lead_modal':
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                    props: { initSelection: flowOptions.LEAD, target: data.payload.lead,
                        navigate: (href) => {
                            if (!href) return;
                            dispatch(setAngularPath(null))
                            setTimeout(() => dispatch(setAngularPath(`user_profile/${href.split('user-profile/')[1]}}`)), 200)
                        }},
                    onClose: () => dispatch(clearUserFlow())})
                break;
            case 'open_link_to_membership_modal':
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                    props: { initSelection: flowOptions.SEND_LINK_TO_MEMBERSHIP_FLOW, target: data.payload.target,
                        navigate: () => null},
                    onClose: () => dispatch(cleanStepper())})
                break;
            case 'toggle_product_updates':
                fetchApi('setProductUpdate', 'post', {}, false, true)
                break;
            case 'set_page_name':
                dispatch(setPageName(t(data.payload.pageName)));
                break;
            case 'reload_page':
                window.location.reload()
                break;
            case 'get_box_integrations':
                sendMessageToAngular('box_info_integrations', {integrations: store.getState().box?.box?.integrations}, 'main_angular_frame_id');
                break;
            case 'open_upgrade_register_link':
                openUpgrade360Link(data.payload);
                break;
            case 'open_convert_link_modal':
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                    props: { initSelection: flowOptions.CONVERT_LINK_FLOW, target: data.payload.target,
                        navigate: () => null},
                    onClose: () => dispatch(cleanStepper())})
                break;
            case 'open_custom_field_edit':
                const customFieldModalManager = store.getState().modalManager;
                if (customFieldModalManager[CREATE_EVENT_MODAL]?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.CUSTOM_FIELD, navigate: (href) => dispatch(setAngularState({navigate: href})), target: data.payload.target ?? null}}))
                break;
            case 'is_box_has_new_site':
                sendMessageToAngular('is_box_has_new_site_info', {isBoxHasNewSite: store.getState().box?.box?.isBoxHasNewSite}, 'main_angular_frame_id');
                break;
            case 'is_box_has_branded_app':
                sendMessageToAngular('is_box_has_branded_app', {isBoxHasBrandedApp: store.getState().box?.box?.white_label_property}, 'main_angular_frame_id');
                break;
            case 'get_auto_tasks':
                dispatch(setSuccessFlag({
                    type: TOAST_TYPE ,
                    message: t('auto-task-created-successfully')
                }))
                dispatch(getAutoActions())
                break;
            case "open_permission_locked_popup":
                openLimitedPackageModal(dispatch, data.payload);
                break;
            case 'send_bugsnag_error':
                const bugsnagUser = store.getState().user?.user;
                Bugsnag.notify(new Error(data.payload.error), function (event) {
                    event.severity = 'error'
                    event.context = data.payload.context
                    event.setUser(bugsnagUser?.id, bugsnagUser?.email, `Boxes Id: ${bugsnagUser?.box_fk}`)
                    event.addMetadata('errorData', { data: data.payload.data })
                });
                break;
            case 'add_edit_box_cancel_reason':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: CANCEL_REASONS, initialValue: {...data.payload, val: data.payload.name, default: getBoxSettingProperties('defaults')?.cancel_reason_id === data.payload.id}, params: data.payload }}))
                break;
            case 'add_edit_box_suspend_reason':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: SUSPEND_REASONS, initialValue: {...data.payload, val: data.payload.name, default: getBoxSettingProperties('defaults')?.suspend_reason_id === data.payload.id}, params: data.payload }}))
                break;
            case 'add_edit_lead_source_type':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: LEAD_SOURCE_TYPE, initialValue: {...data.payload, val: data.payload.name, default: data.payload.id ? getBoxSettingProperties('defaults')?.source_id === data.payload.id : false}, params: data.payload }}))
                break;
            case 'add_edit_lead_status_type':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: LEAD_STATUS_TYPE, initialValue: {...data.payload, val: data.payload.name, default: data.payload.id ? getBoxSettingProperties('defaults')?.lead_status_id === data.payload.id : false}, params: data.payload }}))
                break;
            case 'add_edit_lead_lost_reason':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: LOST_REASONS_TYPE, initialValue: {...data.payload, val: data.payload.name, default: data.payload.id ? getBoxSettingProperties('defaults')?.lost_reason_id === data.payload.id : false}, params: data.payload }}))
                break;
            case 'delete_restore_cancel_reason_successfully':
                dispatch(getBoxCancelReasons());
                break;
            case 'delete_restore_suspend_reason_successfully':
                dispatch(getBoxSuspendReasons());
                break;
            case 'open_required_fields_popup':
                const requiredFieldsManager = store.getState().modalManager;
                if (requiredFieldsManager[CREATE_EVENT_MODAL]?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.USER_FIELDS, navigate: () => {}, initProps: {type: USER_FIELDS}}}))
                break;
            case 'open_required_fields_site_popup':
                const createEventModalForSiteFields = store.getState().modalManager?.createEventModal;
                if (createEventModalForSiteFields?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.USER_FIELDS, navigate: () => {}, initProps: {type: USER_SITE_FIELDS}}}))
                break;
            case 'get_box_settings':
                (async () => {
                    if(store.getState().box?.box?.settings) {
                        sendMessageToAngular('box_settings', {settings: store.getState().box?.box?.settings}, 'main_angular_frame_id');
                    } else {
                        const res = await fetchApi(`boxes/settings`, 'get', null, false, true);
                        sendMessageToAngular('box_settings', {settings: res}, 'main_angular_frame_id');
                    }
                    dispatch(getBoxSettings())
                })()
                break;
            case 'save_box_settings':
                (async () => {
                    await fetchApi(`boxes/settings`, 'POST', data.payload, false, true);
                    dispatch(getBoxSettings())
                })()
                break;
            case 'set_task_as_done':
                fetchApi('tasks/setTaskDone', 'POST', {id: data.payload.taskId, done: data.payload.done}, false, true)
                dispatch(setSidebarCounter())
                break;
            case 'custom_field_delete_success':
                dispatch(getScheduleCustomFields());
                break;
            case 'connect_user_to_group':
                const connectToGroupModalManager = store.getState().modalManager;
                if (connectToGroupModalManager[CREATE_EVENT_MODAL]?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.CONNECT_USER_TO_GROUP, navigate: (href) => {
                            if (!href) return;
                            dispatch(setAngularPath(null))
                            setTimeout(() => dispatch(setAngularPath(`user_profile/${href.split('user-profile/')[1]}}`)), 200)
                        }, target: data.payload.target}}))
                break;
            case 'open_multiple_recurring_update':
                const modalManagerRecurring = store.getState().modalManager[MULTIPLE_RECURRING_PRICE_UPDATE_MODAL];
                if (modalManagerRecurring?.isOpen) return;
                dispatch(openModal({modalName: MULTIPLE_RECURRING_PRICE_UPDATE_MODAL, props: { membershipType: data.payload.membershipType }}))
                break;
            case 'clear_cache':
                sendMessageToAngular('clear_cache', data.payload, 'main_angular_frame_id');
                break;
            case 'open_site_trial_settings_popup':
                const createEventModal = store.getState().modalManager[CREATE_EVENT_MODAL];
                if (createEventModal?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.SITE_TRIAL_SETTINGS, navigate: () => {}}}))
                break;
            case 'open_set_activity_hours_popup':
                const activityHoursModal = store.getState().modalManager[CREATE_EVENT_MODAL];
                if (activityHoursModal?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.GATES_ACTIVITY_HOURS, navigate: () => {}}}))
                break;
            case 'update_lead_lost_reason':
                fetchApi('lead/updateLostReason', 'POST', {...data.payload, users_id: [data.payload.id]}, false, true)
                break;
            case 'open_green_api_popup':
                const whatsappIntegrationModal = store.getState().modalManager[WHATSAPP_INTEGRATION_MODAL];
                if (whatsappIntegrationModal?.isOpen) return;
                dispatch(openModal({modalName: WHATSAPP_INTEGRATION_MODAL, props: { autoGenerate: true}}))
                break;
            case 'open_site_purchase_limitations_popup':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL,  props: {type: SITE_PURCHASE_LIMITATIONS}}))
                break;
            case 'disconnect_green_api':
                fetchApi('boxes/greenApi/disconnect', 'POST', {}, false, true).then(() => {
                    const integrations = store.getState().box?.box?.integrations.filter(integration => integration.name !== 'greenApi');
                    dispatch(updateBox({ integrations }));
                    sendMessageToAngular('box_info_integrations', {integrations}, 'main_angular_frame_id');
                });
                break;
            case 'reboot_green_api':
                fetchApi('boxes/greenApi/reboot', 'POST', {}, false, true).then(() => {
                    const integrations = store.getState().box?.box?.integrations.map(integration => integration.name == 'greenApi' ? ({ ...integration, status: '"starting"' }) : integration);
                    dispatch(updateBox({ integrations }));
                    sendMessageToAngular('box_info_integrations', {integrations}, 'main_angular_frame_id');
                });
                break;
            case 'open_green_api_video':
                const whatsappIntegrationViedoModal = store.getState().modalManager[WHATSAPP_INTEGRATION_MODAL];
                if (whatsappIntegrationViedoModal?.isOpen) return;
                dispatch(openModal({modalName: WHATSAPP_INTEGRATION_MODAL, props: { initialPage: 'video'}}))
                break;
            case 'open_membership_type_props':
                console.log("data.payload", data.payload)
                dispatch(openModal({modalName: MEMBERSHIP_TYPE_PROPS_MODAL, props: { membershipTypeId: data.payload.membershipTypeId }}))
                break;

            case 'open_lead_form_site_popup':
                const createEventModalState = store.getState().modalManager[CREATE_EVENT_MODAL];
                if (createEventModalState?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.SITE_LEAD_FORM, navigate: () => {}}}))
                break;
            case 'get_from_store':
                const key = data.payload.key.split('.');
                let value = store.getState();
                key.forEach((key) => {
                    value = value?.[key];
                });
                sendMessageToAngular('get_from_store', {key: data.payload.key, value}, 'main_angular_frame_id');
                break;
            case 'add_edit_season':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL, props: {type: SEASONS, initialValue: data.payload.season ? { ...data.payload.season, val: data.payload.season.name, hasDateRange: !!data.payload.season.start_date } : {} }}))
                break;
            case 'delete_season':
                (async () => {
                    await fetchApi(`seasons/delete`, 'POST', {id: data.payload.season.id}, false, true);
                    let seasons = [...store.getState().box?.box?.seasons];
                    const deletedSeasonIndex = seasons.findIndex(season => season.id === data.payload.season.id);
                    if (deletedSeasonIndex !== -1) {
                        let season = {...seasons[deletedSeasonIndex]};
                        season.active = 0;
                        seasons[deletedSeasonIndex] = season;
                    }
                    dispatch(updateBox({seasons}));
                    sendMessageToAngular('get_from_store', {key: 'box.box.seasons', value: seasons}, 'main_angular_frame_id');
                })()
                break;

            case 'fetch_recurring_payments':
                dispatch(setRecurringPaymentsFilters({}))
                break;
            case 'open_user_ai_summary':
                dispatch(openModal({modalName: USER_AI_SUMMARY_MODAL, props: {...data.payload}}))
                break;
            case 'open_branded_app_settings':
                dispatch(openModal({ modalName: SETTINGS_VALUE_MODAL, props: {type: BRANDED_APP_SETTINGS}}))
                break;
            case 'create_note_template':
                dispatch(openModal({
                    modalName: CREATE_EVENT_MODAL,
                    props: {
                        initSelection: flowOptions.NOTE_TEMPLATE,
                        target: data.payload?.target ?? null,
                        navigate: () => null
                    },
                    onClose: () => sendMessageToAngular('refetch_note_templates', {}, 'main_angular_frame_id')
                }))
                break;

            case 'create_user_note':
                dispatch(openModal({
                    modalName: CREATE_EVENT_MODAL,
                    props: {
                        initSelection: flowOptions.USER_NOTE,
                        target: data.payload?.target ?? null,
                        initProps: data.payload?.initProps,
                        navigate: () => null
                    },
                    onClose: () => {
                        sendMessageToAngular('refresh_user_notes', {}, 'main_angular_frame_id')
                    }
                }))
                break;

            case 'delete_user_note':
                (async () => {
                    try {
                        await fetchApi('notes/deleteUserNote', 'POST', data.payload, false, true);
                        sendMessageToAngular('refresh_user_notes', {}, 'main_angular_frame_id')
                        sendMessageToAngular('show_success', {}, 'main_angular_frame_id')
                    } catch (error) {
                        sendMessageToAngular('show_fail', {}, 'main_angular_frame_id')
                    }
                })()
                break;

            case 'view_user_note':
                dispatch(openModal({
                    modalName: VIEW_USER_NOTE_MODAL,
                    props: {note: data.payload?.note, closeAfterChange: true},
                }))
                break;
            case 'toggle_note_pin':
                (async () => {
                    await fetchApi('notes/togglePinNote', 'POST', data.payload, false, true)
                    sendMessageToAngular('refresh_user_notes', {}, 'main_angular_frame_id')
                })()
                break;

            case 'generate_mt_description':
                (async () => {
                    try {
                        let threadId = store.getState().ai.threadId;
                        if(!threadId) {
                            const thread = await fetchApi(`ai/createThread`, 'get', null, false, true);
                            threadId = thread.thread_id
                            dispatch(setThreadId(threadId));
                        }
                        let accumulatedText = '';
                        await fetchApiStream('ai/generateMtDescription', 'POST', {...data.payload, threadId}, false, true, null, (chunk) => {
                            accumulatedText += chunk;
                            sendMessageToAngular('generate_mt_description_success', accumulatedText, 'main_angular_frame_id')
                        });
                    } catch (error) {
                        sendMessageToAngular('show_fail', {}, 'main_angular_frame_id')
                    }
                })()
                break;
            case 'update_flow_form':
                dispatch(openModal({
                    modalName: CREATE_EVENT_MODAL,
                    props: {
                        initSelection: flowOptions.FLOW_FORM,
                        target: data.payload?.target ?? null,
                        initProps: data.payload?.initProps,
                        navigate: () => null
                    }
                }))
                break;
            case 'open_site_pixel_modal':
                dispatch(openModal({modalName: SETTINGS_VALUE_MODAL, props: {type: SITE_PIXEL }}))
                break;
            case 'send_close_debt_link':
                dispatch(openModal({
                    modalName: CREATE_EVENT_MODAL,
                    props: {
                        initSelection: flowOptions.SEND_DEBT_LINK,
                        navigate: () => null,
                        initProps: {},
                        target: {user: data.payload}
                    },
                }))
                break;
            case 'open_inbox_ai_popup':
                dispatch(openModal({modalName: CONNECT_TO_INBOX_AI_MODAL}));
                break;
            case 'open_user_charge_popup':
                const createEventModalForUserCharge = store.getState().modalManager?.createEventModal;
                if (createEventModalForUserCharge?.isOpen) return;
                dispatch(openModal({modalName: CREATE_EVENT_MODAL, props: { initSelection: flowOptions.USER_CHARGE_SETTING, navigate: () => {}, initProps: {type: CHARGE_SETTING, paymentProvider: 'grow'}}})) //for now, only grow and site (no app and no other providers)
                break;
        }
    } else if (data.source === 'react') {
        switch (data.action) {
            case 'open_drawer':
                dispatch(setReactState(data.payload));
                break;
            case "close_drawer":
                const iframe1 = document.getElementById("arbox-react-app-wrapper");
                const iWindow1 = iframe1.contentWindow;
                postMessageWithPayload(iWindow1, "rehydrate", data.payload, process.env.REACT_APP_IFRAME_URL);
                break;
            case "open_report":
                dispatch(setReactState({navigate: `/reports${data.payload.isV5 ? '-v5' : ''}/${data.payload.reportName}`}));
                break;
            case "go_back":
                dispatch(setReactState({navigate: `/reports-v5`}));
                break;
            case "member_details":
            case "lead_details":
            case "coach_details":
                window.open(`/user-profile/${data.payload.memberId || data.payload.leadId || data.payload.coachId}`, '_blank');
                break;
            case "navigate_to":
                dispatch(setReactState({navigate: `/${data.payload.path}`}));
                break;
            case "open_upgrade":
                const url = generateUpgradeLink();
                dispatch(setReactState({
                    url: url,
                    position: "center",
                    size: "90%",
                    height: "90%"
                }));
                break;
            case "add_task":
                const taskPopup = store.getState().modalManager;
                if (taskPopup[CREATE_EVENT_MODAL]?.isOpen) return;
                openStepperModal({ dispatch, modalName: CREATE_EVENT_MODAL,
                    props: { initSelection: flowOptions.TASK_FLOW, addAnother: data.payload.target?.id? false : true, navigate: () => {}, target: data.payload.target},
                    onClose: () => {
                        dispatch(cleanStepper())
                        dispatch(setSidebarCounter())
                    }})
                break;
            case "redirect_to_stripe":
                window.location.replace(getRedirectLinkToStripeConnect(store.getState().user?.user, store.getState().box?.box));
                break;
            case "open_permission_locked_popup":
                openLimitedPackageModal(dispatch);
                break;
            case "open_appointment_popup":
                dispatch(setReactState({navigate: `/calendar?action=appointment`}));
                break;
            case "pop_notification":
                const iframe = document.getElementById("arbox-react-app-wrapper");
                const iWindow = iframe.contentWindow;
                postMessageWithPayload(iWindow, "pop_notification", data.payload, process.env.REACT_APP_IFRAME_URL);
                break;
            case "after_rehydrate":
                dispatch(setReactState({}));
                break;
            case 'send_freshpaint_event':
                sendDataEvent(data.payload.eventName, data.payload.metadata);
                break;
            case 'update_counter':
                dispatch(setSidebarCounter())
                break;
        }
    } else if (data.source === 'webFlow') {
        console.log("webFlow" , data);
        switch (data.action.toLowerCase()) {
            case 'intercom': {
                dispatch(setCloseReactIframePopup(true));
                const alignment = i18next?.language === 'he' ? 'left' : 'right';
                window.Intercom?.('boot', {
                    ...window.intercomSettings,
                    alignment: alignment,
                    language_override: data.payload
                });
                window.Intercom?.('show');
                break;
            }
            case 'link': {
                // dispatch(setQuickHelpSource(null));
                dispatch(setCloseReactIframePopup(true));
                dispatch(setQuickHelpSource(data.payload));
                break;
            }
            case 'deeplink': {
                const path = data.payload.split('.com/').pop();
                if (path.includes('external/integrations')) {
                    window.open(t('external-integrations-link'), '_blank');
                    return;
                }
                if (handleLocksPermissionsPath(path, dispatch)) break;
                dispatch(setAngularState({navigate: path}));
                if(isMobile) dispatch(setCloseReactIframePopup(true));
                if (store.getState()?.rootManager?.quickHelpSource === t('product-updates-link')) {
                    // if product updates - deep link will close the popup
                    dispatch(setQuickHelpSource(null));
                }
                break;
            }
            case 'reload':
                const uri = data.payload.split('.com').pop();
                window.location.href = uri
                break;
            case 'stripe': {
                window.location.replace(getRedirectLinkToStripeConnect(store.getState().user?.user, store.getState().box?.box));
                break;
            }
            case 'open_inbox_ai_popup':
                dispatch(openModal({modalName: CONNECT_TO_INBOX_AI_MODAL}));
                break;
            default: {
                break;
            }
        }
    } else if (data.source === 'payments') {
        switch (data.action) {
            case 'open_create_new_client':
                dispatch(openModal({ modalName: CREATE_USER_MODAL, props: {viaFunnel: true, navigate: () => {}, initialValues: {sendWelcomeEmail: false}} }))
                break;
        }
    }
}

const handleLocksPermissionsPath = (path, dispatch) => {
    // TODO: complete all deeplinks
    const hasLock = (permission) => (store.getState().user?.user?.permissions || []).includes(`${permission}Lock`);
    const showLockedPopup = () => openLimitedPackageModal(dispatch);
    if (path.includes('workshop') && hasLock('workshops')) {
        return showLockedPopup();
    }
}

export const addWindowListner = (dispatch) => {
    if (!window.arboxIsListening)
        window.addEventListener("message", function (message) {
            if (message.data.channel === "arbox") {
                microAppActionsHandler(message.data, dispatch);
            }
        });
    window.arboxIsListening = true;
}

export const setDefaultMessageListners = (dispatch) => {
    addWindowListner(dispatch);
}

export const sendMessageToAngular = (message, payload, iframeId = null) => {
    var angularPopupsHandlerIframe = window.document.getElementById(iframeId || "angular-popups-handler-iframe");
    if (!angularPopupsHandlerIframe) return;
    var iWindow = angularPopupsHandlerIframe.contentWindow;
    if (iWindow) {
        iWindow.postMessage(
            {
                channel: "arbox",
                action: message,
                payload: payload || {},
            },
            process.env.REACT_APP_WRAPPER_URL
        );
    }
}

export const sendMessageToIframe = (message, payload, iframeId) => {
    var iframe = document.getElementById(iframeId);
    if (!iframe) return;
    var iWindow = iframe.contentWindow;
    if (iWindow) {
        iWindow.postMessage(
            {
                channel: "arbox",
                action: message,
                payload: payload || {},
            },
            process.env.REACT_APP_WRAPPER_URL
        );
    }
}

const postMessageWithPayload = (target, type, payload, url) => {
    target.postMessage(
        {
            channel: "arbox",
            action: type,
            payload: payload || {},
        },
        url
    );
}

export const sendMessageToPaymentsIframe = (message, payload) => {
    var iframe = document.getElementById('arbox-payments-iframe');
    if (!iframe) return;
    var iWindow = iframe.contentWindow;
    if (iWindow) {
        iWindow.postMessage(
            {
                channel: "arbox",
                action: message,
                payload: payload || {},
            },
            process.env.REACT_APP_PAYMENTS_URL
        );
    }
}